function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
import utils from './utils';
import { MfunsPosDanmaku } from 'mfuns-pos-danmaku';
var AdvancedDanmaku = function () {
    function AdvancedDanmaku(player, data) {
        var _this = this;
        _classCallCheck(this, AdvancedDanmaku);
        this.player = player;
        this.data = data;
        this.posDanmaku = new MfunsPosDanmaku({
            container: this.player.template.advancedDanmaku,
            getDanmaku: function getDanmaku() {
                return data;
            },
            stageSize: [
                1920,
                1080
            ],
            autoResize: false
        });
        this.player.on('danmaku_load_end', function () {
            _this.posDanmaku.resize();
            _this.posDanmaku.reload();
        });
    }
    _createClass(AdvancedDanmaku, [
        {
            key: 'play',
            value: function play() {
                this.posDanmaku.play();
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.posDanmaku.pause();
            }
        },
        {
            key: 'seek',
            value: function seek() {
                this.posDanmaku.seek(this.player.video.currentTime * 1000);
            }
        },
        {
            key: 'load',
            value: function load() {
            }
        },
        {
            key: 'resize',
            value: function resize() {
                this.posDanmaku.resize();
            }
        }
    ]);
    return AdvancedDanmaku;
}();
export {
    AdvancedDanmaku as default
};